import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MARKING_EVENT_TRACK_ACTION } from "@/consts/markingsConst.js";
import helpers from "@/utils/helpers";
import {
  forceStopLoadingOneStep,
  userActionOneStep,
  userSaveDataOneStep,
} from "@/redux/actions/oneStepAction.js";
import { RideButton } from "@rimac-seguros/ride-system-components";
import useRecommendedProductUrl from "@/hooks/useRecommendedProductUrl";

let timerOneStep = null;
let idOneStep = "";

function ButtonLink(props) {
  const {
    soat,
    oneStep,
    mainLinks,
    oneStepData,
    userActionOneStep,
    forceStopLoadingOneStep,
    soatData,
    titleButton,
    link,
    marking,
    client,
  } = props;

  const [linkBtn, setLinkBtn] = useState("");
  const [linkName, setLinkName] = useState("");

  const isLoadedOneStep = !oneStepData.isLoading;
  const isActionUserOneStep = oneStepData.isActionUser;
  const flgDataVeh = oneStepData.data.flgDataVeh;
  idOneStep = `${oneStepData.data.idTrx}`;

  useEffect(() => {
    if (soat && mainLinks) {
      mainLinks.forEach((item) => {
        if (item.key === soat) {
          setLinkBtn(item.link);
          setLinkName(item.title);
        }
      });
    }
  }, [soat]);

  useEffect(() => {
    if (isActionUserOneStep) {
      timerOneStep = setTimeout(() => {
        forceStopLoadingOneStep(idOneStep, { ...soatData, flgDataVeh: true });
      }, 4000);
    }
  }, [isActionUserOneStep]);

  useEffect(() => {
    if (isLoadedOneStep && isActionUserOneStep) {
      clearInterval(timerOneStep);
      openWindowOneStep(idOneStep);
    }
  }, [isLoadedOneStep, isActionUserOneStep]);

  useEffect(() => {
    return () => {
      clearInterval(timerOneStep);
    };
  }, []);

  const getBaseUrl = () => {
    const prodDomains = ['rimac.com', 'www.rimac.com'];
    const isProd = prodDomains.includes(window.location.hostname);

    return isProd ? 'https://www.rimac.com' : 'https://d27e5v3xq6qje3.cloudfront.net';
  };
  
  const urlBase = getBaseUrl();

  const currentLink = link || linkBtn;
  const finalLink = currentLink.replace("[URL]", urlBase);
  const recommendedUrl = useRecommendedProductUrl(finalLink);

  const openWindowOneStep = (idOneStep) => {
    const url = idOneStep
      ? `${recommendedUrl}&id=${idOneStep}`
      : recommendedUrl;

    const handle = window.open(url, "userConsole");

    if (handle == null || typeof handle == "undefined") {
      alert(
        "Por favor habilitar ventanas emergentes para acceder a tu cotizador de SOAT."
      );
    }
  };

  const onClickLink = async (e) => {
    e?.preventDefault();
    if (marking) {
      let name = client
        ? `Cliente ${soatData?.company || ""}`
        : "No tiene SOAT";
      helpers.getTagAction(
        "Consulta SOAT",
        "Resultado",
        name,
        marking,
        MARKING_EVENT_TRACK_ACTION
      );
    }
    if (oneStep) {
      if (isLoadedOneStep) {
        if (flgDataVeh && idOneStep === "" && oneStepData.error === null) {
          userSaveDataOneStep({ ...soatData, flgDataVeh });
        }
        openWindowOneStep(idOneStep);
      } else {
        userSaveDataOneStep({ ...soatData, flgDataVeh });
        userActionOneStep();
      }
    }
  };

  return (
    <RideButton
      text={titleButton || linkName}
      loading={oneStep && isActionUserOneStep && !isLoadedOneStep}
      onClick={onClickLink}
      size="large"
      fullWidth
    />
  );
}

const mapStateToProps = ({ consultReducer, oneStepReducer }) => {
  return {
    soat: consultReducer.statusSOAT,
    soatData: consultReducer,
    oneStepData: oneStepReducer,
  };
};

const mapDsipatchToProps = (dispatch) => {
  return {
    userActionOneStep: () => dispatch(userActionOneStep()),
    forceStopLoadingOneStep: (idTrx, soatData) =>
      dispatch(forceStopLoadingOneStep(idTrx, soatData)),
  };
};

const ButtonLinkR = connect(mapStateToProps, mapDsipatchToProps)(ButtonLink);

export default ButtonLinkR;
